import(/* webpackMode: "eager" */ "/app/app/globals.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/common/BottomTabBar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/providers/PageProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/providers/WrapperProvider.tsx");
